import styles from './template.css';
import {template} from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {isMobile} from '@aoflmkt/is-mobile';
import {isWebpQualifiedMixin} from '@aoflmkt/is-webp-qualified-mixin';
import {accessibilityMixin} from '../../../modules/accessibility-mixin';
import {clickTrackerMixin} from '../../../modules/click-tracker-mixin';
import {cookies, environment, queryParamKeys, queryParamValues} from '../../../modules/constants-enumerate';
import {ModalService} from '../../../modules/modal-service';
import {layoutSdo} from '../../../modules/sdo-layout';
import {homeSdo} from './modules/sdo';
import Cookies from 'js-cookie';

const Mixin = isWebpQualifiedMixin(clickTrackerMixin(accessibilityMixin(AoflElement)));

/**
 *
 * @extends {AoflElement}
 */
@customElement('home-page')
class HomePage extends Mixin {
  /**
   * @readonly
   */
  static is = 'home-page';

  @property({type: String, attribute: false})
  currentYear = (new Date()).getFullYear();

  @property({type: Boolean, attribute: false})
  showAccessibilityLink = (Cookies.get(cookies.COUNTRY_CODE) === 'US');

  @property({type: Boolean, attribute: false})
  androidInApp = (environment.IN_APP && isMobile.android.device);

  @property({type: Boolean, attribute: false})
  iosInApp = (environment.IN_APP && isMobile.apple.device);

  @property({type: String, attribute: false, store: homeSdo, mapState: 'ddMenuColor'})
  ddMenuColor

  /**
   * @param {Event} e
   */
  showMinDeviceReqModal(e) {
    ModalService.show('minDeviceReqModal');
    setTimeout(() => window.dispatchEvent(new CustomEvent('resize')), 500);
  }

  /**
   * @param {Event} e
   */
  showCookieConsentModal(e) {
    ModalService.show('cookieConsentModal');
  }

  /**
   *
   */
  playGameplayVideo() {
    this.video.play();
  }

  /**
   *
   */
  async connectedCallback() {
    super.connectedCallback();
    await this.updateComplete;
    const prospectRegForms = this.shadowRoot.querySelectorAll('.prospect-reg');

    prospectRegForms.forEach((elem) => {
      elem.addEventListener('keypress', (e) => {
        const checkboxFocus = elem.shadowRoot.getElementById('checkbox-focus');
        if (elem.shadowRoot.activeElement === checkboxFocus) {
          if (e.keyCode === 13) {
            checkboxFocus.click();
            checkboxFocus.focus();
          }
        }
      });
    });
    if (environment.IN_APP) return this.logEvent();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const dnsMPI = urlSearchParams.get(queryParamKeys.DNSMPI);
    if (dnsMPI === queryParamValues.DNSMPI) {
      ModalService.show('cookieConsentModal');
    }
  }

  /**
   * @param {String} id
   */
  goTo(id) {
    const target = this.shadowRoot.getElementById(id);
    layoutSdo.ddMenu = false;
    layoutSdo.overlay = false;
    layoutSdo.contentOverlay = false;
    layoutSdo.footerOverlay = false;
    layoutSdo.scrollFreeze(false);
    target.scrollIntoView();
  }

  /**
   * @param {Event} e
   */
  skipNavTo(e) {
    e.preventDefault();
    this.skipNavTarget.focus();
  }

  /**
   *
   */
  async firstUpdated() {
    super.firstUpdated();
    this.video = this.shadowRoot.getElementById('academy-video');
    this.adventureContainer = this.shadowRoot.getElementById('adventure-container');
    this.subjectsContainer = this.shadowRoot.getElementById('subjects-container');
    this.quotesContainer = this.shadowRoot.getElementById('quotes-container');

    if (!isMobile.any) {
      this.adventureContainer.classList.add('fixed');
      this.subjectsContainer.classList.add('fixed');
      this.quotesContainer.classList.add('fixed');
    }

    await this.updateComplete;
    this.topProspectRegForm = this.shadowRoot.getElementById('top-prospect-reg');
    this.learnMoreButton = this.topProspectRegForm.shadowRoot.getElementById('learn-more-link');
    this.emailField = this.topProspectRegForm.shadowRoot.getElementById('top-prospect-reg-email');
    this.skipNavTarget = this.learnMoreButton ? this.learnMoreButton : this.emailField;
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }

  /**
   *
   */
  disconnectedCallback() {
    super.disconnectedCallback();
    homeSdo.reset();
  }
}

export default HomePage;
